'use client'

import { useDocumentInfo } from '@payloadcms/ui'

import { InboxPanelClient } from './InboxPanelClient.jsx'

// Mounted as a UI field on the Deal edit view. Returns null until the deal is
// saved — a thread needs a real dealId to hang off.
export function InboxPanel() {
  const { id } = useDocumentInfo()
  if (!id) return null
  return <InboxPanelClient dealId={id} />
}
